import { render, staticRenderFns } from "./classesCenterLogin.vue?vue&type=template&id=604af831&scoped=true&"
import script from "./classesCenterLogin.vue?vue&type=script&lang=js&"
export * from "./classesCenterLogin.vue?vue&type=script&lang=js&"
import style0 from "./classesCenterLogin.vue?vue&type=style&index=0&id=604af831&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604af831",
  null
  
)

export default component.exports